import {useSalesMarketingApi} from "./useSalesMarketingApi";
import qs from "qs";
import {useContext} from "react";
import {GlobalContext} from "../../../util/state/GlobalContextProvider";

export const usePromoActions = () => {
    const {GET, POST, PUT} = useSalesMarketingApi();
    const {globalData} = useContext(GlobalContext);

    async function getPromoList(filters: any) {
        let params = {
            dealerId: filters.dealer,
            tenantId: filters.legalEntity,
            productCode: filters.productCode ? filters.productCode : undefined,
            promoCode: filters.promoCode ? filters.promoCode : undefined,
            visibility: filters.visibility ? filters.visibility : undefined,
            search: filters.search ? filters.search : undefined,
            offset: filters.offset,
            limit: filters.limit,
            sort: filters.sort ? filters.sort : undefined,
            order: filters.order ? filters.order : undefined
        };
        let data = await GET("sm/promo", false, {
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
        return {
            totalElements: data?.result?.totalElements,
            content: data?.result?.content
        };
    }

    async function getPromoById(id: any) {
        let data = await GET("sm/promo/" + id, true);
        return data?.result;
    }

    async function createPromo(payload: any, ancillaries: any[], earlyBookings: any[]) {
        payload.ancillaryList = ancillaries;
        payload.earlyBookingList = earlyBookings;
       // payload.binCode = payload.binCode.length > 0 ? payload.binCode : undefined;
        return await POST("sm/promo", payload, true)
    }

    async function updatePromo(payload: any, ancillaries: any[], earlyBookings: any[]) {
        payload.ancillaryList = ancillaries;
        payload.earlyBookingList = earlyBookings;
       // payload.binCode = payload.binCode.length > 0 ? payload.binCode : undefined;
        return await PUT("sm/promo", payload, true)
    }

    return {
        getPromoList,
        getPromoById,
        createPromo,
        updatePromo
    };
}